<div class="calendar-container input-group">
  <div type="text" 
        class="form-control delivery-date"
        [dpDayPicker]="datePickerConfig"
        (open)="openedPicker()"
        (close)="closedPicker()"
        (onChange)="changedValue($event)"
        theme="ic-date-picker">
    {{ current }}
    <span *ngIf="!currentDate" class="placeholder">{{placeholder}}</span>
  </div>
  <span class="input-group-btn">
    <button class="btn btn-primary" type="button">
        <i class="fa fa-calendar" aria-hidden="true"></i>
    </button>
  </span>
  <span class="clickarea" (click)="togglePicker()"></span>
</div>
